
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/features/shared/components/ui/button';
import { LayoutGrid, List } from 'lucide-react';

interface ViewModeToggleProps {
  viewMode: 'cards' | 'list';
  onViewModeChange: (mode: 'cards' | 'list') => void;
}

export const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  viewMode,
  onViewModeChange,
}) => {
  const { t } = useTranslation(['employees']);

  return (
    <div className="flex items-center justify-between">
      <div className="flex gap-2">
        <Button
          variant={viewMode === 'cards' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewModeChange('cards')}
          className={viewMode === 'cards' 
            ? 'bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white border-0' 
            : 'border-orange-300 text-orange-700 hover:bg-orange-50'}
        >
          <LayoutGrid className="w-4 h-4 mr-2" />
          {t('employees:directory.cards_view')}
        </Button>
        <Button
          variant={viewMode === 'list' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewModeChange('list')}
          className={viewMode === 'list' 
            ? 'bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white border-0' 
            : 'border-orange-300 text-orange-700 hover:bg-orange-50'}
        >
          <List className="w-4 h-4 mr-2" />
          {t('employees:directory.list_view')}
        </Button>
      </div>
      <div className="text-sm text-orange-600">
        {t('employees:sort_by')}: Name ↓
      </div>
    </div>
  );
};
